import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, Paper, Stack, Typography } from '@mui/material';

interface ResultsSummaryProps {
  totalRecords: number;
  successCount: number;
  failedCount: number;
}

/**
 * Displays a summary of job results with success and failure counts.
 * Shows after job completion.
 */
export default function ResultsSummary({ totalRecords, successCount, failedCount }: ResultsSummaryProps) {
  const hasFailures = failedCount > 0;

  return (
    <Box mb={3}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Job Results
        </Typography>
        <Stack direction="row" spacing={4} alignItems="center">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" color="text.secondary" sx={{ mr: 1 }}>
              Total Records:
            </Typography>
            <Typography variant="h6">{totalRecords}</Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircleIcon color="success" sx={{ mr: 0.5 }} />
            <Typography variant="body1" color="text.secondary" sx={{ mr: 1 }}>
              Succeeded:
            </Typography>
            <Typography variant="h6" color="success.main">
              {successCount}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ErrorIcon color={hasFailures ? 'error' : 'disabled'} sx={{ mr: 0.5 }} />
            <Typography variant="body1" color="text.secondary" sx={{ mr: 1 }}>
              Failed:
            </Typography>
            <Typography variant="h6" color={hasFailures ? 'error.main' : 'text.secondary'}>
              {failedCount}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
}
